module.exports = "/subscriptions/assets/42c1207c1bc45b49c3d8d49585bc8b12.png";